module.exports = __webpack_public_path__ + "img/multi_terminal.5da704a1.png";